const state = {
	user_id: null,
	email: null,
	data: null
}

const getters = {
	hasEmail() {
		return Boolean(state.email)
	}
}

const actions = {
	initializeBrazeUser({
		commit
	}, user_id) {
		commit('setUserId', user_id)
	}
}

const mutations = {
	setUserId(state, user_id) {
		state.user_id = user_id
	},

	setEmail(state, email) {
		state.email = email
	},

	setUserData(state, userData) {
		const { data } = userData
		if (data) userData.data = JSON.parse(data)
		state.data = userData
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
